import styled from 'styled-components'
import expandImg from '../../images/main/select2.png'

const Wrapper = styled.div`
  margin-left: ${({ hasChildren }) => (hasChildren ? '-14px' : '0px')};
`

const Node = styled.div`
  display: table;
  width: 100%;
`

const Expander = styled.div`
  display: table-cell;
  cursor: pointer;
  padding: 2px 7px;
  font-size: 10px;
  background: transparent url(${expandImg}) no-repeat;
  background-position: ${({ isExpanded }) => (isExpanded ? '-20px -4px' : '-2px -4px')};
`

const Option = styled.div`
  display: table-cell;
  cursor: pointer;
  width: 100%;
  padding: 2px 2px 0 2px;
  border-radius: 3px;

  &:hover {
    background-color: #eee;
  }
`

const Children = styled.div`
  margin-left: 34px;
`

export default {
  Node,
  Option,
  Wrapper,
  Expander,
  Children
}
